import React from "react";
import { DoneAll, Done, Close } from "@material-ui/icons";
import { Container } from "./styles";

function chooseIcon(source, type) {
  if (source?.status == "sent") return <Done style={{ color: "#A0BF92" }} />;

  if (source?.status == "delivered")
    return <DoneAll style={{ color: "#A0BF92" }} />;

  if (source?.status == "viewed" && type?.includes("audio/"))
    return <DoneAll style={{ color: "#A0BF92" }} />;

  if (["viewed", "played"].includes(source?.status))
    return <DoneAll style={{ color: "#34B7F1" }} />;

  if (source?.status == "not_found") return <Close style={{ color: "#000" }} />;
}

function AckFeedback({ ack, messageType}) {
  return (
    <Container>
      {chooseIcon(ack?.whatsapp || ack?.email, messageType)}
    </Container>
  );
}

export default AckFeedback;
